import ajax from 'axios'
import $ from 'jquery'

ajax.defaults.headers.common['X-CSRF-Token'] = $('meta[name="csrf-token"]').attr('content')

window.ajax = ajax

export default ajax
